import React, { Suspense } from "react";

import { Category } from "@faire/retailer/models/Category/Category";
import { getSettingAndAssignEnableSDUIHubPage } from "@faire/retailer/settings/getSettingEnableSDUIHubPage";
import { getSettingSDUICategoryPagePathNavigationPaths } from "@faire/retailer/settings/getSettingSDUICategoryPagePathNavigationPaths";
import { CategoryPageRequestParamsProvider } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/CategoryPageRequestParamsProvider";
import { useHubPageBase } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/LazyHubPageBase";
import { useLoggedInCategoryPageBase } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/LazyLoggedInCategoryPageBase";
import { CategoryPagePrefetcher } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/CategoryPagePrefetcher";
import { CurrentCategoryPageContextProvider } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/currentCategoryPageContext";
import { HubPagePrefetcher } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/HubPagePrefetcher";
import { useCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { LoggedInCategoryPageLoadingSkeleton } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedInCategoryPageLoadingSkeleton";

interface IProps {
  category: Category;
  navigationPath: string;
}

export const LoggedInCategoryPage = (props: IProps) => {
  const { category, navigationPath } = props;

  return (
    <CurrentCategoryPageContextProvider value={{ category, navigationPath }}>
      <CategoryPageRequestParamsProvider>
        <LoggedInCategoryPageBase />
      </CategoryPageRequestParamsProvider>
    </CurrentCategoryPageContextProvider>
  );
};

const LoggedInCategoryPageBase = () => {
  const LoggedInCategoryPageBase = useLoggedInCategoryPageBase();
  const HubPageBase = useHubPageBase();
  const navigationPath = useCurrentNavigationPath();
  const isSDUICategoryPage =
    getSettingSDUICategoryPagePathNavigationPaths().includes(navigationPath);
  const shouldRenderSDUICategoryPage =
    isSDUICategoryPage && getSettingAndAssignEnableSDUIHubPage();

  return (
    <>
      {shouldRenderSDUICategoryPage ? (
        <HubPagePrefetcher />
      ) : (
        <CategoryPagePrefetcher />
      )}

      <Suspense fallback={<LoggedInCategoryPageLoadingSkeleton />}>
        {shouldRenderSDUICategoryPage ? (
          <HubPageBase />
        ) : (
          <LoggedInCategoryPageBase />
        )}
      </Suspense>
    </>
  );
};
